import React from 'react';

import { AuHeading } from 'components/DTA';

import styles from './ApplicationName.module.scss';

interface IApplicationName {
  name: string | React.ReactElement;
}

const ApplicationName: React.FC<IApplicationName> = ({ name }) => (
  <AuHeading className={styles.applicationName} level='1' size='xl'>{name}</AuHeading>
);

export default ApplicationName;